import React from 'react'
import Navbar from './Navbar/Navbar'
import '../styles/global.scss'
import Footer from './Footer/footer';


const Layout = ({ children, data }) => {
  
  return (
    <>
      <div className="container">
        <Navbar />
        {children}
        <Footer/>
      </div>
    </>
  );
};
 
export default Layout;